import { useState, useEffect, useRef } from 'react'

export default function useComponentVisible(initialIsVisible = false) {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible)
  const ref = useRef(null)

  const handleClickOutside = (event) => {
    if (
      ref.current &&
      !ref.current.contains(event.target) &&
      !document.querySelector('[role="dialog"]') &&
      !document.querySelector('[id="schedule-notification"]')
    ) {
      setIsComponentVisible(false)
    }
    // else setIsComponentVisible(true)
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [])

  return { ref, isComponentVisible, setIsComponentVisible }
}
